/**
 * @class routeHelper.
 *
 */
import { createHashHistory } from 'history';
import store from '../../../reducers/storeRegistration';
import notificationActions from '../../../actions/notificationActionCreators';
const hashHistory = createHashHistory();

/* eslint class-methods-use-this:
  ["error", { "exceptMethods": [
    "handleViewRedirect",
    "transitionAsync",
    "updateURL",
    "displayModal"
  ] }]
*/
// Needs to stay a class to allow us to bind components to transitionAsync calls
class RouteHelper {
  handleViewRedirect(canView, currentLocation) {
    if (!canView) {
      const location = currentLocation ? ": ".concat(currentLocation.pathname) : '';
      store.dispatch(notificationActions.error({
        message: "You are not authorized to access this resource".concat(location, ".")
      }));
      hashHistory.replace('/accessDenied');
    }
  }
  updateURL() {
    let route = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '/file-cabinet';
    hashHistory.push(route);
  }
  handleEntityDoesNotExist(pathname) {
    this.updateURL(pathname);
    store.dispatch(notificationActions.error({
      headerMessage: 'Error fetching requested data',
      message: 'Please try again.'
    }));
  }
  transitionAsync(component, entity, next) {
    let safeRoutes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
    if (!component || !component.props || !component.props[entity]) {
      throw new Error("Component ".concat(entity, " is misconfigured"));
    }
    // if the next route is allowed, don't block the transition
    if (safeRoutes.length && safeRoutes.indexOf(next.pathname) !== -1) {
      return true;
    }
    const _component$props$enti = component.props[entity],
      loading = _component$props$enti.loading,
      pendingChanges = _component$props$enti.pendingChanges,
      error = _component$props$enti.error;
    // Handle 410 errors (entity deleted by another user)
    if (error && error.response && error.response.status === 410) {
      const entityActions = component.props["".concat(entity, "Actions")];
      entityActions.showCancel(next.pathname);
      return true;
    }

    // cancel transition if data is loading
    if (loading && pendingChanges) {
      store.dispatch(notificationActions.info({
        headerMessage: 'Please wait, your changes are being saved.',
        message: 'If saving takes too long, you may be experiencing connection issues.'
      }));
      return false;
    }

    // Check for changes
    const entityActions = component.props["".concat(entity, "Actions")];
    const canEdit = component.props.canEdit;

    // If the user can't edit anyways, no point in bothering to block
    // the transition, just post the notice and let the transition carry on
    if (!canEdit) {
      store.dispatch(notificationActions.error({
        message: 'You are not authorized to make changes'
      }));
      entityActions.showCancel(next.pathname);
      return true; // Prompt will handle transition
    }

    // if true is not being returned, prompt still replaces the url with the
    // target, so we need to clean it up by changing it back to the current
    // location, otherwise subsequent navigations will fail
    hashHistory.replace(component.props.match.url);
    this.displayModal(component.handleSave, entityActions.showCancel, hashHistory.replace, next.pathname);
    return false;
  }

  /**
   * Display a modal with a set of actions
   */
  displayModal(_yesAction, _noAction) {
    let historyAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : () => {};
    let pathname = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    store.dispatch(notificationActions.save({
      noAction: () => {
        _noAction(pathname);
        historyAction(pathname);
      },
      yesAction: () => _yesAction(pathname)
    }, {
      autoClose: false
    }));
    return false;
  }
}
export default new RouteHelper();